import i18next, {
    InitOptions,
    Module,
    TFunction,
    TOptions,
    i18n,
} from 'i18next';

export type OneServiceI18nOptions = {
    init: InitOptions;
    plugins?: Module[];
};

export class BaseOneServiceI18n {
    protected readonly client: i18n = i18next.createInstance();

    public async init(opts: OneServiceI18nOptions): Promise<TFunction> {
        opts.plugins?.forEach((p) => {
            this.client.use(p);
        });

        return await this.client.init({
            load: 'currentOnly',
            fallbackLng: false,
            saveMissing: true,
            missingKeyHandler: (lng, ns, key, fallbackValue) => {
                console.warn('MISSING TRANSLATION: ', {
                    languages: lng,
                    namespace: ns,
                    key,
                    fallbackValue,
                });
            },
            ...opts.init,
            initImmediate: false,
        });
    }

    public getClient(): i18n {
        return this.client;
    }

    public get(
        keys: string | string[],
        opts?: string | TOptions<InitOptions>
    ): string {
        return this.client.t(keys, opts);
    }

    public exists(key: string): boolean {
        return this.client.exists(key);
    }
}
